import { atom } from "recoil";

const startLoaderAtom = atom({
  key: "startLoaderState",
  default: false,
});

export default startLoaderAtom;
